import { writable, derived } from 'svelte/store';

const LANGUAGE_KEY = 'bau-da-gata-language';
const DEFAULT_LANGUAGE = 'pt';

/**
 * Available translations
 */
const translations = {
  pt: {
    // Header
    'header.lightMode': 'Modo claro',
    'header.darkMode': 'Modo escuro',
    
    // Navigation
    'nav.home': 'Início',
    'nav.catalog': 'Catálogo',
    'nav.about': 'Sobre',
    'nav.contact': 'Contato',
    
    // Catalog
    'catalog.title': 'Nossos Produtos',
    'catalog.subtitle': 'Peças únicas selecionadas com carinho',
    'catalog.loading': 'Carregando produtos...',
    'catalog.empty': 'Nenhum produto disponível no momento',
    'catalog.error': 'Erro ao carregar produtos',
    'catalog.retry': 'Tentar novamente',
    'catalog.filter.all': 'Todos',
    'catalog.filter.clothes': 'Roupas',
    'catalog.filter.accessories': 'Acessórios',
    'catalog.search': 'Buscar produtos...',
    
    // Item
    'item.price': 'Preço',
    'item.size': 'Tamanho',
    'item.condition': 'Estado',
    'item.category': 'Categoria',
    'item.description': 'Descrição',
    'item.interested': 'Tenho interesse',
    'item.close': 'Fechar',
    'item.available': 'Disponível',
    'item.sold': 'Vendido',
    
    // WhatsApp
    'whatsapp.message': 'Olá! Tenho interesse no produto:\n\nCódigo: {sku}\n{productName}\nPreço: R$ {price}',
    'whatsapp.button': 'Conversar no WhatsApp',
    
    // About
    'about.title': 'Sobre o Baú da Gata',
    'about.whoWeAre': 'Quem Somos',
    'about.description1': 'O Baú da Gata é um brechó online de curadoria, criado a partir de um olhar atento e do cuidado com cada escolha. Aqui, nada é por acaso. Cada item é selecionado com critério, valorizando qualidade, estética e consumo consciente.',
    'about.description2': 'Mais do que um brechó feminino, o Baú reúne roupas, acessórios e diversos artigos únicos, escolhidos por meio de um garimpo cuidadoso. Nosso objetivo é oferecer peças que continuem em uso, com originalidade e propósito.',
    'about.description3': 'Acreditamos que estilo, casa e rotina também são formas de expressão. Por isso, o Baú da Gata existe para quem busca boas escolhas, exclusividade e um brechó de roupas e acessórios que vai além do óbvio.',
    'about.description4': 'Abra o Baú e descubra seus próximos achados.',
    'about.ourValues': 'Nossos Valores',
    'about.curation': 'Curadoria consciente',
    'about.curationDesc': 'Cada item é escolhido com critério, intenção e responsabilidade, priorizando qualidade, estética e continuidade de uso.',
    'about.exclusivity': 'Exclusividade com propósito',
    'about.exclusivityDesc': 'Valorizamos peças e artigos únicos, que fogem do óbvio e incentivam escolhas mais pessoais e menos padronizadas.',
    'about.consumption': 'Consumo responsável',
    'about.consumptionDesc': 'Acreditamos em um consumo mais inteligente, que prolonga o uso dos produtos e respeita pessoas, histórias e recursos.',
    'about.contactUs': 'Entre em Contato',
    'about.contactDesc': 'Tem dúvidas ou quer saber mais sobre alguma peça? Fale conosco!',
    'about.whatsappButton': 'WhatsApp',
    'about.whatsappMessage': 'Olá! Gostaria de saber mais sobre o Baú da Gata.',
    'about.emailButton': 'Enviar E-mail',
    'about.emailSubject': 'Contato - Baú da Gata',
    'about.emailBody': 'Olá! Gostaria de saber mais informações sobre...',
    'about.emailLabel': 'E-mail',
    
    // Contact
    'contact.title': 'Contato',
    'contact.description': 'Entre em contato conosco! Estamos aqui para tirar suas dúvidas e ajudar você a encontrar a peça perfeita.',
    'contact.getInTouch': 'Fale Conosco',
    'contact.whatsappButton': 'WhatsApp',
    'contact.whatsappMessage': 'Olá! Gostaria de saber mais sobre o Baú da Gata.',
    'contact.emailButton': 'Enviar E-mail',
    'contact.emailSubject': 'Contato - Baú da Gata',
    'contact.emailBody': 'Olá! Gostaria de saber mais informações sobre...',
    'contact.emailLabel': 'E-mail',
    'contact.followUs': 'Siga-nos nas Redes Sociais',
    'contact.socialDesc': 'Acompanhe nossas novidades e peças exclusivas nas redes sociais!',
    
    // Not Found
    'notFound.title': 'Página não encontrada',
    'notFound.description': 'A página que você procura não existe.',
    'notFound.backHome': 'Voltar ao início',
    
    // Error
    'error.title': 'Ops! Algo deu errado',
    'error.reload': 'Recarregar página',
    'error.goHome': 'Ir para o início',
    
    // Cookies
    'cookies.title': 'Utilizamos cookies',
    'cookies.description': 'Usamos cookies para melhorar sua experiência e analisar o tráfego do site. Ao continuar navegando, você concorda com nossa política de privacidade.',
    'cookies.accept': 'Aceitar',
    'cookies.decline': 'Recusar',
    
    // Footer
    'footer.rights': 'Todos os direitos reservados.',
    'footer.privacy': 'Privacidade',
    'footer.terms': 'Termos'
  },
  en: {
    // Header
    'header.lightMode': 'Light mode',
    'header.darkMode': 'Dark mode',
    
    // Navigation
    'nav.home': 'Home',
    'nav.catalog': 'Catalog',
    'nav.about': 'About',
    'nav.contact': 'Contact',
    
    // Catalog
    'catalog.title': 'Our Products',
    'catalog.subtitle': 'Unique pieces selected with care',
    'catalog.loading': 'Loading products...',
    'catalog.empty': 'No products available at the moment',
    'catalog.error': 'Error loading products',
    'catalog.retry': 'Try again',
    'catalog.filter.all': 'All',
    'catalog.filter.clothes': 'Clothes',
    'catalog.filter.accessories': 'Accessories',
    'catalog.search': 'Search products...',
    
    // Item
    'item.price': 'Price',
    'item.size': 'Size',
    'item.condition': 'Condition',
    'item.category': 'Category',
    'item.description': 'Description',
    'item.interested': "I'm interested",
    'item.close': 'Close',
    'item.available': 'Available',
    'item.sold': 'Sold',
    
    // WhatsApp
    'whatsapp.message': 'Hello! I am interested in the product:\n\nCode: {sku}\n{productName}\nPrice: R$ {price}',
    'whatsapp.button': 'Chat on WhatsApp',
    
    // About
    'about.title': 'About Baú da Gata',
    'about.whoWeAre': 'Who We Are',
    'about.description': 'Baú da Gata is an online thrift store specializing in unique and special pieces. We believe in sustainable fashion and the value of second-hand items, offering carefully selected clothing and accessories with care.',
    'about.ourValues': 'Our Values',
    'about.curation': 'Conscious Curation',
    'about.curationDesc': 'Each item is chosen with criteria, intention, and responsibility, prioritizing quality, aesthetics, and continued use.',
    'about.exclusivity': 'Purposeful Exclusivity',
    'about.exclusivityDesc': 'We value unique pieces and articles that defy the obvious and encourage more personal, less standardized choices.',
    'about.consumption': 'Responsible Consumption',
    'about.consumptionDesc': 'We believe in smarter consumption that extends product lifespan and respects people, stories, and resources.',
    'about.contactUs': 'Contact Us',
    'about.contactDesc': 'Have questions or want to know more about any piece? Contact us!',
    'about.whatsappButton': 'WhatsApp',
    'about.whatsappMessage': 'Hello! I would like to know more about Baú da Gata.',
    'about.emailButton': 'Send Email',
    'about.emailSubject': 'Contact - Baú da Gata',
    'about.emailBody': 'Hello! I would like to know more information about...',
    'about.emailLabel': 'Email',
    
    // Contact
    'contact.title': 'Contact',
    'contact.description': 'Get in touch with us! We are here to answer your questions and help you find the perfect piece.',
    'contact.getInTouch': 'Get in Touch',
    'contact.whatsappButton': 'WhatsApp',
    'contact.whatsappMessage': 'Hello! I would like to know more about Baú da Gata.',
    'contact.emailButton': 'Send Email',
    'contact.emailSubject': 'Contact - Baú da Gata',
    'contact.emailBody': 'Hello! I would like to know more information about...',
    'contact.emailLabel': 'Email',
    'contact.followUs': 'Follow Us on Social Media',
    'contact.socialDesc': 'Follow our news and exclusive pieces on social media!',
    
    // Not Found
    'notFound.title': 'Page not found',
    'notFound.description': 'The page you are looking for does not exist.',
    'notFound.backHome': 'Back to home',
    
    // Error
    'error.title': 'Oops! Something went wrong',
    'error.reload': 'Reload page',
    'error.goHome': 'Go to home',
    
    // Cookies
    'cookies.title': 'We use cookies',
    'cookies.description': 'We use cookies to improve your experience and analyze site traffic. By continuing to browse, you agree to our privacy policy.',
    'cookies.accept': 'Accept',
    'cookies.decline': 'Decline',
    
    // Footer
    'footer.rights': 'All rights reserved.',
    'footer.privacy': 'Privacy',
    'footer.terms': 'Terms'
  }
};

/**
 * Get initial language from localStorage or browser
 * @returns {string}
 */
function getInitialLanguage() {
  if (typeof window === 'undefined') return DEFAULT_LANGUAGE;
  
  const stored = localStorage.getItem(LANGUAGE_KEY);
  if (stored && translations[stored]) {
    return stored;
  }
  
  // Try to detect browser language
  const browserLang = navigator.language?.split('-')[0];
  if (browserLang && translations[browserLang]) {
    return browserLang;
  }
  
  return DEFAULT_LANGUAGE;
}

/**
 * Current language store
 */
function createLanguageStore() {
  const { subscribe, set } = writable(DEFAULT_LANGUAGE);

  return {
    subscribe,
    set: (lang) => {
      if (translations[lang]) {
        if (typeof window !== 'undefined') {
          localStorage.setItem(LANGUAGE_KEY, lang);
          document.documentElement.lang = lang;
        }
        set(lang);
      }
    }
  };
}

export const currentLanguage = createLanguageStore();

/**
 * Initialize language on app start
 */
export function initializeLanguage() {
  const lang = getInitialLanguage();
  currentLanguage.set(lang);
}

/**
 * Set language
 * @param {string} lang - Language code (pt, en)
 */
export function setLanguage(lang) {
  currentLanguage.set(lang);
}

/**
 * Translation function store
 * Returns translated string with optional parameter substitution
 */
export const t = derived(currentLanguage, ($lang) => {
  /**
   * @param {string} key - Translation key
   * @param {Record<string, string>} [params] - Optional parameters for substitution
   * @returns {string}
   */
  return (key, params = {}) => {
    const translation = translations[$lang]?.[key] || translations[DEFAULT_LANGUAGE]?.[key] || key;
    
    // Replace parameters like {paramName}
    return Object.entries(params).reduce(
      (str, [param, value]) => str.replace(new RegExp(`\\{${param}\\}`, 'g'), value),
      translation
    );
  };
});

/**
 * Get all available languages
 * @returns {string[]}
 */
export function getAvailableLanguages() {
  return Object.keys(translations);
}
